<mat-toolbar color="primary">
    <a routerLink="/">{{ appName }}</a>
    <span class="fill-remaining-space"></span>
    <a routerLink="/admin" routerLinkActive="active" *ngIf="authSvc.userData$ | async">
        <button mat-button>
          <mat-icon>build</mat-icon>
        </button>
    </a>

    <!-- <a routerLink="/about" routerLinkActive="active">
    <button mat-button>About</button>
  </a> -->

    <a *ngIf="authSvc.userData$ | async; else showLogin" (click)="onLogout()">
        <button mat-button>
          <mat-icon>account_balance_wallet</mat-icon>
        </button>
    </a>

    <ng-template #showLogin>
        <a routerLink="/login" routerLinkActive="active">
            <button mat-button><mat-icon>account_circle</mat-icon></button>
        </a>
    </ng-template>
</mat-toolbar>
